import './card-link-slider.scss';
import Splide from '@splidejs/splide';

export class CardLinkSlider {
  constructor() {
    this.el = document.querySelector('.js-card-link-slider-slider');
    if (!this.el) return;

    this.mediaQuery = window.matchMedia('(min-width: 992px)');
    this.splide = null;

    this.handleResize = this.handleResize.bind(this);
    this.onResize = this.debounce(this.handleResize, 150);

    this.init();
  }

  init() {
    // check iniziale
    this.handleResize();

    // listener breakpoint
    this.mediaQuery.addEventListener('change', this.handleResize);

    // listener resize
    window.addEventListener('resize', this.onResize);
  }

  handleResize() {
    if (this.mediaQuery.matches) {
      this.mountSlider();
    } else {
      this.destroySlider();
    }
  }

  mountSlider() {
    if (this.splide) return;

    this.splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage: 2.5,
      focus: 0,
      drag: true,
      trimSpace: true,
      snap: true,
    });

    this.splide.mount();
    this.initArrows();
  }

  destroySlider() {
    if (!this.splide) return;

    this.splide.destroy(true);
    this.splide = null;
  }

  initArrows() {
    const prev = this.el.querySelector('.splide__arrow--prev');
    const next = this.el.querySelector('.splide__arrow--next');

    const updateArrows = () => {
      if (!this.splide) return;
      if (!this.mediaQuery.matches) return;

      const { index } = this.splide;
      const last = this.splide.length - this.splide.options.perPage;

      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }

      if (this.splide.length <= this.splide.options.perPage) {
        prev.classList.add('is-removed');
        next.classList.add('is-removed');
      } else {
        prev.classList.remove('is-removed');
        next.classList.remove('is-removed');
      }
    };

    updateArrows();
    this.splide.on('mounted move', updateArrows);
  }

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }
}
